import { DataList, DataListItem } from '@app/components/DataList'
import ExpandableContent from '@app/components/ExpandableContent'
import LotEditorModal from '@app/components/LotEditorModal'
import { ILot } from '@app/models/Lot'
import { bindFunctions } from '@app/utils/class'
import * as React from 'react'
import { Card, CardBody, CardTitle } from 'reactstrap'

interface ILotCardProps {
  actions?: React.ReactNode
  className?: string
  lot: ILot
  editModalOpen?: any
  onCancelClicked?: () => void
  onOkClicked?: (e: ILot) => void
  propertyId?: string
  style?: React.CSSProperties
}

export default class LotCard extends React.PureComponent<ILotCardProps> {
  constructor(props: any) {
    super(props)

    bindFunctions(this)
  }

  public render() {
    return (
      <Card
        className={this.props.className}
        style={{ borderRadius: 'md', ...this.props.style }}
      >
        <CardBody>
          <div className='d-flex justify-content-between'>
            <CardTitle>Lot: {this.props.lot.lotNo}</CardTitle>
            <div> {this.props.actions} </div>
          </div>
          <LotEditorModal
            isOpen={this.props.editModalOpen || false}
            lot={this.props.lot}
            onConfirmClick={this._onOkClicked}
            onCancelClick={this._onCancelClicked}
          />
          <DataList>
            <DataListItem
              label='Lot Size'
              value={this.props.lot.lotSize.toString()}
            />
            <DataListItem
              label='APN / Parcel ID'
              value={this.props.lot.parcelId}
            />
            <DataListItem
              label='Minimum Divisible'
              value={this.props.lot.minDivisible}
              visible={this.props.lot.minDivisible > 0}
            />
            <DataListItem
              label='Maximum Contiguous'
              value={this.props.lot.maxContiguous}
              visible={this.props.lot.maxContiguous > 0}
            />
          </DataList>
          {this.props.lot.lotDescription && (
            <div className='mt-2'>
              <div>Description</div>
              <ExpandableContent>
                <div className='white-space-pre'>
                  {this.props.lot.lotDescription}
                </div>
              </ExpandableContent>
            </div>
          )}
        </CardBody>
      </Card>
    )
  }

  private _onCancelClicked() {
    if (this.props.onCancelClicked) {
      this.props.onCancelClicked()
    }
  }

  private _onOkClicked(value: ILot) {
    if (this.props.onOkClicked) {
      this.props.onOkClicked(value)
    }
  }
}
